import { stockTypeEnum } from "@gtpl/shared-models/common-models";
import { RmOccupancyEnum, RmRackPositionEnum, RmRackPositionTypeEnum } from "@gtpl/shared-models/masters";
import {Column,Entity,JoinColumn,ManyToOne,OneToMany,PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Rack } from "../racks/racks.entity";
import { RmRack } from "../rm-racks/rm-racks.entity";

@Entity('rm_rack_position_log')
export class RmRackPositionLog {
  @PrimaryGeneratedColumn('increment', { name: 'rm_rack_position_log_id' })
  rmRackPositionId: number;

  @Column("varchar",{
    nullable:false,
    length:20,
    name:"rm_rack_code"
  })
  rmRackCode:string;

  @Column('int', {
    nullable: false,
    name: 'rm_rack_id'
  })
  rmRackId: number;
  @Column('int', {
    nullable: false,
    name: 'zone_id'
  })
  zoneId: number;
  
  @Column('int', {
    nullable: false,
    name: 'plant_id',
    default:0
  })
  plantId: number;
  
  @Column('int', {
    nullable: true,
    name: 'old_sale_order_id'
  })
  oldSaleOrderId: number;
  @Column('int', {
    nullable: true,
    name: 'new_sale_order_id'
  })
  newSaleOrderId: number;
  @Column('int', {
    nullable: true,
    name: 'old_sale_order_item_id'
  })
  oldSaleOrderItemId: number;
  @Column('int', {
    nullable: true,
    name: 'new_sale_order_item_id'
  })
  newSaleOrderItemId: number;
  @Column('int', {
    nullable: true,
    name: 'old_varient_id'
  })
  oldVarientId: number;
  @Column('int', {
    nullable: true,
    name: 'new_varient_id'
  })
  newVarientId: number;
  @Column('int', {
    nullable: true,
    name: 'new_brand_id'
  })
  newBrandId: number;
  @Column('int', {
    nullable: true,
    name: 'old_brand_id'
  })
  oldBrandId: number;
  @Column('int', {
    nullable: true,
    name: 'old_item_sub_category_id'
  })
  OldItemSubCategoryId: number;
  @Column('int', {
    nullable: true,
    name: 'new_item_sub_category_id'
  })
  newItemSubCategoryId: number;

  @Column({
    type: 'enum',
    enum: RmOccupancyEnum,
    nullable: false,
    default: RmOccupancyEnum.NOT_OCCUPIED,
    name: 'old_occupancy'
  })
  oldOccupancy: RmOccupancyEnum;
  @Column({
    type: 'enum',
    enum: RmOccupancyEnum,
    nullable: false,
    default: RmOccupancyEnum.NOT_OCCUPIED,
    name: 'new_occupancy'
  })
  newOccupancy: RmOccupancyEnum;
  
  @Column({
    type: 'enum',
    enum: stockTypeEnum,
    nullable: true,
    default: stockTypeEnum.SaleOrder,
    name: 'old_reserved_for'
  })
  oldReservedFor: stockTypeEnum;
  @Column({
    type: 'enum',
    enum: stockTypeEnum,
    nullable: true,
    default: stockTypeEnum.SaleOrder,
    name: 'new_reserved_for'
  })
  newReservedFor: stockTypeEnum;

  @Column('boolean', {
    nullable: false,
    default: false,
    name: 'old_is_reserved',
  })
  OldIsReserved: boolean;
  @Column('boolean', {
    nullable: false,
    default: false,
    name: 'new_is_reserved',
  })
  newIsReserved: boolean;

  @Column("date", {
    nullable: true,
    name: "old_reserved_date"
  })
  oldReservedDate: Date;
  @Column("date", {
    nullable: true,
    name: "new_reserved_date"
  })
  newReservedDate: Date;

  @Column('boolean', {
    nullable: false,
    default: true,
    name: 'is_active',
  })
  isActive: boolean;

  @CreateDateColumn({
    name: 'created_at',
    type: 'datetime',
  })
  createdAt: Date;

  @Column('varchar', {
    nullable: false,
    name: 'created_user',
    length: 50,
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: 'updated_at',
    type: 'datetime',
  })
  updatedAt: Date;

  @Column('varchar', {
    nullable: true,
    name: 'updated_user',
    length: 50,
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: 'version_flag',
  })
  versionFlag: number;

}

